function Loader() {
  return (
    <div className="absolute top-0 left-0 w-full h-full bg-transparent bg-opacity-50 flex justify-center items-center z-50">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
    </div>
  );
}
export default Loader;
